import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { TailSpin } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import { REGEX } from "common/constants/constants";
import TextField from "common/TextField";

import { CommonButton } from "components/common/button/Button";
import Loader from "components/common/loader/Loader";
import { Form, Formik, useFormik, useFormikContext } from "formik";
import * as Yup from "yup";

import {
  getBranchProductPaymentInfo,
  updateBranchProductPaymentInfo,
  updateBranchProductPaymentInfoNew,
  getBranchProductPaymentInfoNew,
} from "services/branchServices";
import "./branchDetails.scss";
import { useTranslation } from "react-i18next";
import { getSecretKey } from "services/bankServices";
import { encrypt } from "utils/Utils";
import "./branchDetails.scss";
const PaymentInfo = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { imageUrl, translatedValue, pathIds } = location.state;
  const [paymentInfo, setPaymentInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [initialValues, setInitialValues] = useState({
    // accountHolder: "",
    // bic: "",
    // iban: "",
    creditEnabled: false,
    creditEntityId: "",
    sepaEnabled: false,
    sepaEntityId: "",
    accessToken: "",
    premiumSubscriptionPrice: 0,
    proSubscriptionPrice: 0,
  });

  const [secretKey, setSecretKey] = useState("");
  const handleBranchProductPaymentInfo = async () => {
    setIsLoading(true);
    let { success = false, payLoad = null } =
      await getBranchProductPaymentInfoNew(pathIds);
      debugger;
    if (success) {
      if (payLoad) {
        setPaymentInfo(payLoad);
        let creditStar = "";
        let sepaStart = "";
        if (payLoad?.creditEnabled) {
          creditStar = "********************************";
        }

        if (payLoad?.sepaEnabled) {
          sepaStart = "********************************";
        }
        const {
          creditEnabled,
          creditEntityId = creditStar || "",
          sepaEnabled,
          sepaEntityId = sepaStart || "",
          accessToken = "********************************",
          premiumSubscriptionPrice,
          proSubscriptionPrice,
        } = payLoad;
        setInitialValues({
          creditEnabled,
          creditEntityId,
          sepaEnabled,
          sepaEntityId,
          accessToken,
          premiumSubscriptionPrice,
          proSubscriptionPrice,
        });
      }
    }
    setIsLoading(false);
  };
  const getPayloadSecretKey = async () => {
    const result = await getSecretKey();
    setSecretKey(result?.payLoad?.secret);
  };
  useEffect(() => {
    getPayloadSecretKey();
    handleBranchProductPaymentInfo();
  }, []);

  const validate = Yup.object({
    // accountHolder: Yup.string()
    //   .matches(REGEX.accountHolder, t("invalid-format"))
    //   .required(t("required")),
    // bic: Yup.string()
    //   .matches(REGEX.bic, "The format should be (e.g. AAAADE0A)")
    //   .required(t("required")),
    // iban: Yup.string()
    //   .matches(
    //     REGEX.iban,
    //     "The format should be (e.g. DE00 0000 0000 0000 0000 00)"
    //   )
    //   .required(t("required")),
    creditEnabled: Yup.boolean(),
    creditEntityId: Yup.string(),
    sepaEnabled: Yup.boolean(),
    SepaEntityId: Yup.string(),
    accessToken: Yup.string(),
    premiumSubscriptionPrice: Yup.number().positive(
      t("number-validation-message")
    ),
    proSubscriptionPrice: Yup.number().positive(t("number-validation-message")),
  });

  const handleSubmit = async (values) => {
    setIsSending(true);
    const { branchProductAccountId = "" } = paymentInfo;
    const payload = {
      ...(branchProductAccountId && { branchProductAccountId }),
      // ...values,
      // bankPayment: {
      creditEnabled: values.creditEnabled,
      creditEntityId:
        values.creditEntityId === "********************************" ||
        values.creditEntityId === ""
          ? ""
          : encrypt(values.creditEntityId, secretKey),
      sepaEnabled: values.sepaEnabled,
      sepaEntityId:
        values.sepaEntityId === "********************************" ||
        values.sepaEntityId === ""
          ? ""
          : encrypt(values.sepaEntityId, secretKey),
      accessToken:
        values.accessToken === "********************************" ||
        values.accessToken === ""
          ? ""
          : encrypt(values.accessToken, secretKey),
      premiumSubscriptionPrice: values.premiumSubscriptionPrice || 0.1,
      proSubscriptionPrice: values.proSubscriptionPrice || 0.1,
      // },
    };
    const result = await updateBranchProductPaymentInfoNew(pathIds, payload);
debugger;
    if (!result.success) {
      toast.error(result?.data?.message);
      setIsSending(false);
    } else {
      toast.success(t("successfully-saved-payment"));
    }
    setIsSending(false);
  };
  const customStyle = {
    ".css-dncllk-MuiInputBase-root-MuiFilledInput-root": {
      borderRadius: "0 !important",
    },
    "&.MuiTextField-root": {
      minWidth: "auto !important",
      maxWidth: "100% !important",
    },
    "@media screen and (max-width: 992px)": {
      width: "100%",
      margin: "10px 0",
    },
  };
  const getDisableFunc = (
    creditEnabled,
    creditEntityId,
    sepaEnabled,
    sepaEntityId,
    accessToken,
    premiumSubscriptionPrice,
    proSubscriptionPrice
  ) => {
    return (creditEnabled == false || creditEntityId != "") &&
      (sepaEnabled == false || sepaEntityId != "") &&
      (creditEnabled == true || sepaEnabled == true || accessToken != "") &&
      (creditEnabled == true ||
        sepaEnabled == true ||
        premiumSubscriptionPrice == 0 ||
        proSubscriptionPrice == 0)
      ? false
      : creditEnabled == false && sepaEnabled == false
      ? false
      : true;
  };
  return (
    <div className="payment-info-container">
      <Toaster />
      <p className="page-title">{t("payment-information")}</p>
      <hr />
      {isLoading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validate}
          enableReinitialize={true}
          onSubmit={(values) => handleSubmit(values)}
        >
          {(formik) => {
            const {
              creditEnabled,
              creditEntityId,
              sepaEnabled,
              sepaEntityId,
              accessToken,
              premiumSubscriptionPrice,
              proSubscriptionPrice,
            } = formik.values;
            return (
              <Form onSubmit={formik.handleSubmit}>
                <Row className="branch-details upload-file">
                  <Col lg={8} xs={12}>
                    <div className="d-flex my-3">
                      <img
                        src={`/assets/icons${imageUrl}`}
                        width={50}
                        height={50}
                      />
                      <p style={{ fontWeight: "600" }} className="my-3 px-2">
                        {translatedValue}
                      </p>
                    </div>
                    <p style={{ fontWeight: "600" }} className="my-3">
                      {t("payment-information")}
                    </p>
                    <p className="my-3">
                      Bitte ergänzen Sie hier die Zahlungsinformationen für die
                      Gutschriften.
                    </p>
                    {/* <div className="d-flex flex-lg-nowrap flex-wrap w-100 my-5 justify-content-between">
                        <TextField
                          id="accountHolder"
                          label="Kontoinhaber"
                          name="accountHolder"
                          varient="filled"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            ...customStyle,
                            width: "48%",
                          }}
                          InputLabelProps={{
                            sx: {
                              color: "#000 !important",
                            },
                          }}
                        />
                        <TextField
                          id="bic"
                          label="BIC"
                          name="bic"
                          varient="filled"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            ...customStyle,
                            width: "48%",
                          }}
                          InputLabelProps={{
                            sx: {
                              color: "#000 !important",
                            },
                          }}
                        /> 

                      </div>*/}
                    <div className="d-flex flex-column w-50 my-5 justify-content-between">
                      <div className="inputField2 mt-2 ">
                        <div className="checkBox">
                          <label style={{ margin: "0 1rem" }}>
                            {" "}
                            {t("enable-credit-card")}{" "}
                          </label>
                          <input
                            defaultChecked={formik?.values?.creditEnabled}
                            name="creditEnabled"
                            type="checkbox"
                            onChange={formik?.handleChange}
                          />
                        </div>
                        <TextField
                          type="text"
                          className="form-control"
                          placeholder={t("credit-entity-id")}
                          name="creditEntityId"
                          isDisabled={!formik?.values?.creditEnabled}
                        />
                      </div>
                      <div className="inputField2 mt-2 ">
                        <div className="checkBox">
                          <label style={{ margin: "0 1rem" }}>
                            {" "}
                            {t("enable-sepa")}{" "}
                          </label>
                          <input
                            name="sepaEnabled"
                            type="checkbox"
                            defaultChecked={formik?.values?.sepaEnabled}
                            onChange={formik?.handleChange}
                          />
                        </div>
                        <TextField
                          type="text"
                          className="form-control"
                          placeholder={t("sepa-entity-id")}
                          name="sepaEntityId"
                          isDisabled={!formik?.values?.sepaEnabled}
                        />
                      </div>
                      <div className="inputField2 mt-2">
                        <label style={{ margin: "0.5rem 1rem" }}>
                          {" "}
                          {t("access-token")}
                        </label>
                        <TextField
                          type="text"
                          className="form-control"
                          placeholder={t("access-token")}
                          name="accessToken"
                          isDisabled={
                            !(
                              formik?.values?.creditEnabled ||
                              formik?.values?.sepaEnabled
                            )
                          }
                        />
                      </div>
                      <div className="inputField2 mt-2 ">
                        <label style={{ margin: "0.5rem 1rem" }}>
                          {" "}
                          {t("subscription-price-premium")}
                        </label>
                        <TextField
                          type="number"
                          className="form-control"
                          placeholder={t("subscription-price-premium")}
                          name="premiumSubscriptionPrice"
                          isDisabled={
                            !(
                              formik?.values?.creditEnabled ||
                              formik?.values?.sepaEnabled
                            )
                          }
                        />
                      </div>
                      <div className="inputField2 mt-2 ">
                        <label style={{ margin: "0.5rem 1rem" }}>
                          {" "}
                          {t("subscription-price-pro")}
                        </label>
                        <TextField
                          type="number"
                          className="form-control"
                          placeholder={t("subscription-price-pro")}
                          name="proSubscriptionPrice"
                          isDisabled={
                            !(
                              formik?.values?.creditEnabled ||
                              formik?.values?.sepaEnabled
                            )
                          }
                        />
                      </div>
                      <div className=" my-5 d-flex justify-content-end">
                        <button
                          className={`${
                            !getDisableFunc(
                              creditEnabled,
                              creditEntityId,
                              sepaEnabled,
                              sepaEntityId,
                              accessToken,
                              premiumSubscriptionPrice,
                              proSubscriptionPrice
                            )
                              ? ""
                              : "opacity-50"
                          } update-btn mb-5 mt-3 `}
                          disabled={getDisableFunc(
                            creditEnabled,
                            creditEntityId,
                            sepaEnabled,
                            sepaEntityId,
                            accessToken,
                            premiumSubscriptionPrice,
                            proSubscriptionPrice
                          )}
                          type="submit"
                        >
                          {isSending ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            t("save")
                          )}
                        </button>
                        {/* <button

                          className={`${!getDisableFunc(creditEnabled,
                            creditEntityId,
                            sepaEnabled,
                            sepaEntityId,
                            accessToken,
                            subscriptionPrice)
                            ? ""
                            : "opacity-50"
                            } update-btn mb-5 mt-3 `}
                          disabled={
                            getDisableFunc(creditEnabled,
                              creditEntityId,
                              sepaEnabled,
                              sepaEntityId,
                              accessToken,
                              subscriptionPrice)

                          }
                          type="submit">
                          {isSending ? (
                            <div className="d-flex flex-row gap-3">

                              <TailSpin
                                height="20"
                                width="20"
                                color="#ffff"
                                radius="1"
                                visible={true}
                              />
                              {t("save")}
                            </div>
                          ) : (
                            t("save")
                          )}
                        </button> */}
                        {/* <CommonButton
                          title={
                            isSending ? (
                              <TailSpin
                                height="20"
                                width="20"
                                color="#ffff"
                                radius="1"
                                visible={true}
                              />
                            ) : (
                              t("save")
                            )
                          }
                          disabled={disabled}
                          border="none"
                          borderRadius="5px"
                          type="submit"
                        /> */}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      )}
    </div>
  );
};

export default PaymentInfo;
